/**
 * Utility functions for managing tag filters
 */
import { Tag } from '@juno/client-api/model';

/**
 * Type definition for tag filters group
 */
export interface TagFilterGroup {
  tagType: string;
  tags: string[];
}

/**
 * Adds a tag to the filters
 * @param prevFilters - The current filters object
 * @param tag - The tag to add
 * @returns Updated filters object with the tag added
 */
export const appendTagFilterUtil = (prevFilters: { tags?: TagFilterGroup[] } = {}, tag: Tag) => {
  const tags = prevFilters.tags
    ? prevFilters.tags.map((tagGroup) => ({
        ...tagGroup,
        tags: [...tagGroup.tags],
      }))
    : [];

  const tagFilterIndex = tags.findIndex((t) => t.tagType === tag.type.id);

  if (tagFilterIndex !== -1) {
    tags[tagFilterIndex] = {
      ...tags[tagFilterIndex],
      tags: [...tags[tagFilterIndex].tags, tag.id],
    };
  } else {
    tags.push({ tagType: tag.type.id, tags: [tag.id] });
  }

  return {
    ...prevFilters,
    tags,
  };
};

/**
 * Removes a tag from the filters
 * @param prevFilters - The current filters object
 * @param tag - The tag to remove
 * @returns Updated filters object with the tag removed
 */
export const removeTagFilterUtil = (prevFilters: { tags?: TagFilterGroup[] } = {}, tag: Tag) => {
  const tags = prevFilters.tags
    ? prevFilters.tags.map((tagGroup) => ({
        ...tagGroup,
        tags: [...tagGroup.tags],
      }))
    : [];

  const tagFilterIndex = tags.findIndex((t) => t.tagType === tag.type.id);

  if (tagFilterIndex !== -1) {
    const updatedTags = tags[tagFilterIndex].tags.filter((t) => t !== tag.id);

    if (updatedTags.length === 0) {
      tags.splice(tagFilterIndex, 1);
    } else {
      tags[tagFilterIndex] = {
        ...tags[tagFilterIndex],
        tags: updatedTags,
      };
    }
  }

  return {
    ...prevFilters,
    tags: tags.length === 0 ? [] : tags,
  };
};
